import { render, staticRenderFns } from "./ProjectIssueCounts.vue?vue&type=template&id=566e673e&scoped=true"
import script from "./ProjectIssueCounts.vue?vue&type=script&lang=js"
export * from "./ProjectIssueCounts.vue?vue&type=script&lang=js"
import style0 from "./ProjectIssueCounts.vue?vue&type=style&index=0&id=566e673e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e673e",
  null
  
)

export default component.exports